module.exports = __webpack_public_path__ + "static/img/phone-default.13a02736.png";